import {ThemeModel} from "../shared/definition/model/theme.model";

export const THEMES: Record<string, ThemeModel> = {
    'default-theme': {
        cssClass: 'ui-default-theme',
        alias: 'Verde e Branco',
        colors: [''],
        key: 'default-theme',
        isLight: true
    },
    'white-purple-theme': {
        cssClass: 'ui-white-purple-theme',
        alias: 'Branco e Roxo',
        colors: ['rgb(126 87 255)', 'rgb(249 250 251)'],
        key: 'white-purple-theme',
        isLight: true
    },
    'white-blue-theme': {
        cssClass: 'ui-white-blue-theme',
        alias: 'Branco e Azul',
        colors: ['rgb(13 161 229)', 'rgb(249 250 251)'],
        key: 'white-blue-theme',
        isLight: true
    },
    'dark-green-theme': {
        cssClass: 'ui-dark-green-theme',
        alias: 'Cinza esverdeado e Verde',
        colors: ['rgb(0 163 136)', 'rgb(15 25 23)'],
        key: 'dark-green-theme',
        isLight: false
    },
    'dark-theme': {
        cssClass: 'ui-dark-theme',
        alias: 'Cinza e Verde',
        colors: ['rgb(46 213 115)', 'rgb(18 20 22)'],
        key: 'dark-theme',
        isLight: false
    },
    'dark-blue-theme': {
        cssClass: 'ui-dark-blue-theme',
        alias: 'Cinza e Azul',
        colors: ['rgb(13 161 229)', 'rgb(18 20 22)'],
        key: 'dark-blue-theme',
        isLight: false
    }
};
